/** @format */

import { MemberCircle } from "./unionType";
import {
	EmptyAddress,
	EmptyEmployer,
	EmptyPhoneContact,
	IAddress,
	IEmployer,
	IPhoneContact,
	IUser,
} from "./userType";

// export interface ICreateCircle {
//   _id?: string;
//   circleName: string;
//   circleImage?: any;
//   description: string;
//   leader: string;
//   membersCount: string;
//   // contributions?: ContributionType[];
//   // payOuts?: PayOutType[];

//   memberId?: string;
//   contributionAmount: string;
//   maxContributionTime?: string;
//   contributionPeriod: string; //Will Adjust as needed
//   contributionDays: string[];

//   userId?: string;
//   payOutPeriod: string; // Will Adjust as needed
//   payOutDay: string[];
// }

export interface ICreateCircle {
	circleName: string;
	circleImage?: File | null; // Assuming you're handling file uploads for images
	description: string;
	leader: string; // Leader's ID
	membersCount: string;
	members?: string[]; // Array of member IDs
	contribution?: ContributionType[]; // Align this with your server's expectations
	payOut?: PayOutType; // Align this with your server's expectations
	configuration?: Configuration;
}

export interface IUserAddRequest {
	_id?: string;
	member: string;
	status: string;
	union: {
		_id: string;
	};
}

export interface AcceptAddRequest {
	union: MemberCircle;
	user: IUser;
}

export interface AcceptJoinRequest {
	joinRequest: IJoinRequestItem;
	circle: MemberCircle;
}

export interface ICircleInfo {
	_id?: string;
	circleName: string;
	circleImage?: any;
	description: string;
	leader: LeaderType;
	joinRequests?: IJoinRequestItem[];
	membersCount: string;
	members?: [
		{
			memberId: string;
			hasAgreedToCircleTerms: boolean;
		}
	];
	contributions: ContributionType[];
	configuration?: Configuration;
	payOut?: PayOutType;
	created_At?: any;
	updated_At?: any;
	// Admin ban fields
	isBanned?: boolean;
	bannedAt?: Date;
	banReason?: string;
	// Active cycle detection
	hasActiveCycle?: boolean;
	activeCycleInfo?: {
		startDate: string;
		endDate: string;
		payOutDate: string;
		timezone?: string;
	} | null;
}

export interface CircleData {
	_id?: string;
	circleName: string;
	circleImage?: any;
	description: string;
	leader: LeaderType;
	membersCount: string;
	members?: [
		{
			memberId: Partial<IUser>;
			hasAgreedToCircleTerms: boolean;
		}
	];
	contributions: ContributionType[];
	configuration?: Configuration;
	payOut: PayOutType;
	created_At?: any;
	updated_At?: any;
	// Admin ban fields
	isBanned?: boolean;
	bannedAt?: Date;
	banReason?: string;
	// Active cycle detection
	hasActiveCycle?: boolean;
	activeCycleInfo?: {
		startDate: string;
		endDate: string;
		payOutDate: string;
		timezone?: string;
	} | null;
}

export interface LeaderType {
	_id: string;
	email: string;
	firstName: string;
	lastName: string;
	profileImage: string;
}

// ContributionType
export interface ContributionType {
	_id?: string;
	memberId?: string;
	contributionAmount: number;
	maxContributionTime?: any;
	contributionPeriod: string; //Will Adjust as needed
	contributionDays: string[];
}

export interface Configuration {
	_id?: string;
	contributionAmount: any;
	maxContributionTime?: any;
	contributionPeriod: string; //Will Adjust as needed
	contributionDays: string[];
	contributionFrequency: number;
	payOutPeriod: string; // Will Adjust as needed
	payOutDay: string;
	country?: string; // ISO country code (e.g. "US", "CA", "GB")
	currency?: string; // ISO currency code (e.g. "usd", "cad", "gbp")
}

export interface ICircleStripeConnectedAccountBalance {
	unionId: string;
	circleName: string;
	stripeAccountId: string;
	balance: {
		object: string;
		available: [
			{
				amount: string;
				currency: string;
				source_types: {
					card: number;
				};
			}
		];
		instant_available: [
			{
				amount: string;
				currency: string;
				source_types: {
					card: number;
				};
			}
		];
		livemode: false;
		pending: [
			{
				amount: string;
				currency: string;
				source_types: {
					card: number;
				};
			}
		];
	};
	payOut: string;
}

export interface ICircleExpectedTotalPayOut {
	unionId: string;
	circleName: string;
	activeMembers: number;
	contributionAmount: string;
	contributionPeriod: string;
	contributionDaysCount: number;
	cyclesMultiplier: number;
	contributionsPerMember: number;
	expectedTotalPayout: string;
}

export const EmptyContributionType: ContributionType[] = [
	{
		memberId: "",
		contributionAmount: 0,
		maxContributionTime: "",
		contributionPeriod: "",
		contributionDays: [],
	},
];

export const EmptyConfigurationType: Configuration = {
	contributionAmount: 0,
	maxContributionTime: "",
	contributionPeriod: "",
	contributionDays: [],
	contributionFrequency: 0,
	payOutPeriod: "", // Will Adjust as needed
	payOutDay: "",
};

// PayOutType
export interface PayOutType {
	_id?: string;
	userId?: string;
	payOutPeriod: string; // Will Adjust as needed
	payOutDay: string;
}

export const EmptyPayOutType: PayOutType = {
	userId: "",
	payOutPeriod: "",
	payOutDay: "",
};

export interface ICirclePayload {
	userId: string;
	email: string;
	reason: string;
	hasAgreedToTerms: boolean;
}

export interface ICircleLeaderApplication {
	_id?: string;
	email: string;
	reason: string;
	userId: string;
	status?: string;
	hasAgreedToTerms: boolean;
	created_At?: string;
	updated_At?: string;
}

export interface ICircleLeaderApplicationPayload {
	_id?: string;
	email: string;
	reason: string;
	userId: string;
	status?: string;
	hasAgreedToTerms: boolean;
}

export const EmptyCirclePayload = {
	userId: "",
	email: "",
	reason: "",
};

export const CircleLeaderApplicationPayload = {
	userId: "",
	email: "",
	reason: "",
};

export enum IAccountVerificationStatus {
	Pending = "Pending",
	Approved = "Approved",
	Rejected = "Rejected",
}

export interface IAccountVerification {
	userId: string;
	address: IAddress;
	phone: IPhoneContact;
	sourceOfIncome?: ISourceOfIncome;
	employer?: IEmployer;
	relatives?: IRelatives;
	status?: IAccountVerificationStatus;
	dateOfBirth: string;
	lawfulIdNumber: string;
	socialSecurityNumber?: string;
	isEmployed?: boolean;
}
export interface IAccountVerificationPayload {
	userId: string;
	dateOfBirth: string;
	lawfulIdNumber: string;
	socialSecurityNumber?: string;
	phone: IPhoneContact;
	address: IAddress;
	employer?: IEmployer;
	relatives?: IRelatives;
	status?: IAccountVerificationStatus;
	isEmployed?: boolean;
	sourceOfIncome?: ISourceOfIncome;
}

export interface ISourceOfIncome {
	sourceType: string;
	incomeAmount: string;
}

export const EmptySourceOfIncome: ISourceOfIncome = {
	sourceType: "",
	incomeAmount: "",
};

export interface IRelatives {
	fullName: string;
	address: IAddress;
	phone: IPhoneContact;
}

export const EmptyRelatives: IRelatives = {
	fullName: "",
	address: EmptyAddress,
	phone: EmptyPhoneContact,
};

export const EmptyCircleLeaderVerificationPayload = {
	userId: "",
	dateOfBirth: "",
	lawfulIdNumber: "",
	socialSecurityNumber: "",
	phone: EmptyPhoneContact,
	address: EmptyAddress,
	employer: EmptyEmployer,
	relatives: EmptyRelatives,
	isEmployed: false,
	sourceOfIncome: EmptySourceOfIncome,
};

export interface UnionInfo {
	_id: string;
	circleName: string;
	circleImage: string;
	description: string;
	membersCount: string;
	members: string[];
	invitedMembers: string[];
	joinRequests: IJoinRequestItem[];
	leader: string;
	contributions: string[];
	payOuts: string[];
	created_At: string;
	updated_At: string;
}

export interface AddRequest {
	member: string;
	union: string;
	status: string;
	_id: string;
	created_At: string;
	updated_At: string;
}

export enum JoinRequestStatus {
	Pending = "Pending",
	Approved = "Approved",
	Rejected = "Rejected",
}

export interface JoinRequest {
	_id: string;
	circle: string;
	status: JoinRequestStatus;
	user: IUser;
	reason: string;
	deniedAt?: string | null;
	created_At?: string;
	updated_At?: string;
}

export interface LeaderSendAddRequestInfo {
	message: string;
	union: UnionInfo;
	addRequest: AddRequest;
}

export interface JoinRequestInfo {
	message: string;
	circle: UnionInfo;
	joinRequest: JoinRequest;
	user: IUser;
}

export interface IUserId {
	_id: string;
	firstName: string;
	lastName: string;
	profileImage: string;
	email: string;
}

export interface IJoinRequestItem {
	_id: string;
	userId: IUserId;
	circleId: string;
	reason: string | null;
	rating: number;
	status: JoinRequestStatus;
	deniedAt: string | null;
	created_At: string;
	updated_At: string;
	__v: number;
}

export interface JoinRequestsOfCircleResult {
	joinRequests: IJoinRequestItem[];
}

export interface IJoinRequestCircle {
	_id: string;
	circleName: string;
	circleImage: string;
	description: string;
	joinRequests: IJoinRequestItem[];
}

export interface JoinRequestOfCircleByCircleLeaderIdResult {
	circles: IJoinRequestCircle[];
}

export interface IUpdateCircle {
	circleName?: string;
	circleImage?: string | File | null;
	description?: string;
	members?: string[];
	leader?: string;
	membersCount?: string;
	contribution?: ContributionType[];
	configuration?: Configuration;
	payOut?: PayOutType;
}

export interface ContributionUpdateType {
	_id?: string;
	memberId?: string;
	contributionAmount?: number | string;
	maxContributionTime?: number | string;
	contributionPeriod?: string;
	contributionDays?: string[];
}

export interface PayOutUpdateType {
	_id?: string;
	userId?: string;
	payOutPeriod?: string;
	payOutDay?: string[];
}

export interface JoinRequestUserSent {
	_id: string;
	userId: string;
	circleId: Partial<UnionInfo>;
	reason: string;
	status: string;
	deniedAt: any;
	created_At: any;
	updated_At: any;
}

export interface IUnionCycleBalances {
	unionId: string;
	unionName: string;
	cycleId: string;

	cycleContributions: {
		totalAmount: string;
		totalFees: string;
		netAmount: string;
		memberCount: number;
		memberBreakdown: {
			memberId: string;
			memberName: string;
			memberEmail?: string;
			totalContributed: number;
			totalContributedDollars: string;
			numberOfContributions: number;
			averageContribution: number;
			averageContributionDollars: string;
			lastContribution?: string;
		}[];
	};

	unionOverall: {
		currentLiability: string;
		totalHistoricalContributions: string;
		totalHistoricalPayouts: string;
		lastActivity?: string;
	};

	timestamp: Date;
}

export interface CircleContributionSummary {
	circleId: string;
	circleName: string;
	currentMonthTotal: number;
	currency?: string;
	contributionCount?: number;
	lastContributionDate: string | null;
	activeMembers?: number;
}

export interface AllCirclesContributionResponse {
	month: string;
	year: number;
	totalCircles: number;
	totalUsers: number;
	totalContributions: number;
	totalAmount: number;
	totalPayouts: number;
	totalPayoutAmount: number;
	successRate?: number;
	currency: string;
	circles: CircleContributionSummary[];
	generatedAt: string;
}

export interface DailyContribution {
	date: string;
	totalAmount: number;
	contributionCount: number;
}

export interface MonthContributionData {
	month: string;
	year: number;
	dailyData: DailyContribution[];
	chartData: number[];
	totalAmount: number;
	totalContributions: number;
}

export interface ContributionsChartResponse {
	currentMonth: MonthContributionData;
	previousMonth: MonthContributionData;
	generatedAt: string;
}

// Admin API response types
export interface AdminFetchAllCirclesResponse {
	total?: number;
	circles: ICircleInfo[];
	generatedAt?: string;
}

export interface AdminCircleResponse {
	success?: boolean;
	circle?: ICircleInfo;
	updatedCircle?: ICircleInfo;
	message?: string;
}

export interface AdminDeleteCircleResponse {
	success?: boolean;
	deletedCircleId?: string;
	message?: string;
}

// Admin Join Request Types
export interface AdminJoinRequestUser {
	_id: string;
	firstName: string;
	lastName: string;
	email: string;
	profileImage?: string;
	isVerified: boolean;
	employer?: {
		income?: number;
		employerName?: string;
		yearsWithEmployer?: number;
	};
}

export interface AdminJoinRequestCircle {
	_id: string;
	circleName: string;
	circleImage?: string;
	description: string;
	membersCount: string;
	leader: {
		_id: string;
		firstName: string;
		lastName: string;
		email: string;
	};
	members: Array<{
		memberId: string;
		hasAgreedToCircleTerms: boolean;
		joinedAt: string;
	}>;
	configuration?: Configuration;
}

export interface AdminJoinRequestItem {
	_id: string;
	userId: AdminJoinRequestUser;
	circleId: AdminJoinRequestCircle;
	reason: string;
	status: JoinRequestStatus;
	deniedAt: string | null;
	created_At: string;
	updated_At: string;
	rating: number;
}

export interface JoinRequestsApplications {
	joinRequests: AdminJoinRequestItem[];
	totalCount: number;
	meta: {
		requestedAt: string;
	};
}

export interface AdminApproveJoinRequestResponse {
	success: boolean;
	message: string;
	joinRequest: AdminJoinRequestItem;
	circle: {
		_id: string;
		circleName: string;
		circleImage?: string;
	};
	user: {
		_id: string;
		firstName: string;
		lastName: string;
		email: string;
	};
	meta: {
		requestedAt: string;
	};
}

export interface AdminRejectJoinRequestResponse {
	success: boolean;
	message: string;
	joinRequest: AdminJoinRequestItem;
	circle: {
		_id: string;
		circleName: string;
		circleImage?: string;
	};
	user: {
		_id: string;
		firstName: string;
		lastName: string;
		email: string;
	};
	meta: {
		requestedAt: string;
	};
}

// Add Request Status Enum
export enum AddRequestStatus {
	Pending = "Pending",
	Approved = "Approved",
	Rejected = "Rejected",
}

export interface AdminAddRequestUser {
	_id: string;
	firstName: string;
	lastName: string;
	email: string;
	profileImage?: string;
}

export interface AdminAddRequestCircle {
	_id: string;
	circleName: string;
	circleImage?: string;
	totalMembers?: number;
	leader: {
		_id: string;
		firstName: string;
		lastName: string;
		email: string;
	};
}

export interface AdminAddRequestItem {
	_id: string;
	member: AdminAddRequestUser;
	union: AdminAddRequestCircle;
	status: AddRequestStatus;
	createdAt: string;
	updatedAt: string;
}

export interface AddRequestsApplications {
	success: boolean;
	count: number;
	data: AdminAddRequestItem[];
}

export interface AdminApproveAddRequestResponse {
	success: boolean;
	message: string;
	data: {
		addRequestId: string;
		status: AddRequestStatus;
		member: {
			id: string;
			firstName: string;
			lastName: string;
			email: string;
		};
		circle: {
			id: string;
			circleName: string;
		};
	};
}

export interface AdminRejectAddRequestResponse {
	success: boolean;
	message: string;
	data: {
		addRequestId: string;
		status: AddRequestStatus;
		member: {
			id: string;
			firstName: string;
			lastName: string;
			email: string;
		};
		circle: {
			id: string;
			circleName: string;
		};
	};
}
